import create from "zustand";
export default create((set) => {
    return {
        cameraMode: 'none',
        setCameraMode: (mode) => {
            set(() => {
                return { cameraMode: mode }
            })
        }
    }
})